import { Navigate, Route, Routes } from "react-router-dom"
import { Provider } from "react-redux"
import { DashboardUser } from "@hydrologiq/common/providers/FirebaseAuth"
import store from "./state/store"
import Providers from "@hydrologiq/shared/providers/Providers"
import { RouteProvider, Section } from "@hydrologiq/shared/providers/RouteProvider"
import ScrollToTop from "@hydrologiq/shared/ScrollToTop"
// import Order from "./views/Order"
import Orders from "./views/Orders"
import OrderSelection from "./components/selection/OrderSelection"
// import OrdersCalendar from "./views/OrdersCalendar"
import OrdersActivities from "./views/OrdersActivities"
import { useGetFeature } from "@hydrologiq/shared/providers/helpers/useFeature"

function Routing(props: { basePath?: string; user?: DashboardUser; container?: React.RefObject<HTMLElement> }) {
  const sectionPath = "orders"
  const { basePath = sectionPath, user, container } = props
  const activityless = useGetFeature("orders_activityless")

  return (
    <Provider store={store}>
      <ScrollToTop />
      <Routes>
        {!basePath && <Route path={sectionPath} element={<Navigate to={"/"} />} />}
        <Route
          path={basePath}
          element={
            <RouteProvider route={basePath} section={Section.ORDERS}>
              <Providers container={container} user={user}>
                <OrderSelection />
              </Providers>
            </RouteProvider>
          }
        >
          <Route index element={<Orders />} />
          {/* Calendar moved to standalone section: /planner */}
          {/* <Route path="calendar" element={<OrdersCalendar />} /> */}
          {!activityless && <Route path="activities" element={<OrdersActivities />} />}
        </Route>
      </Routes>
    </Provider>
  )
}

export default Routing
